export default __webpack_public_path__ + "static/media/stat3.0a8295b1.png";